<template>
  <div class="my-wrapper" v-if="this.$store.getters.userInfo">
    <div class="user-info">
      <img
        :src="this.$store.getters.userInfo.headImageUrl"
        alt=""
        class="user-icon"
      />
      <div class="name-info">
        <span>{{ this.$store.getters.userInfo.nickname }}</span>
        <!--0 已过期 非vip 1 vip-->
        <img
          :src="
            this.$store.getters.userInfo.vipStatus
              ? require('@/assets/imgs/my/my_vip.png')
              : require('@/assets/imgs/my/my_unvip.png')
          "
          alt=""
          class="icon"
        />
      </div>
      <div class="read-days">累计阅读{{this.$store.getters.userInfo.readDays}}天~</div>
    </div>

    <!--vip-->
    <div
      class="vip-wrapper"
      :class="[this.$store.getters.userInfo.vipStatus == 1 ? 'vip' : 'vip-un']"
    >
      <p v-if="this.$store.getters.userInfo.vipStatus == 1" class="vip-date">
        会员有效期: {{ showDate }}
      </p>
      <van-button class="vip-btn" plain type="info" @click="action_addVip()"
        >立即加入</van-button
      >
    </div>

    <!--积分 阅读天数-->
    <div class="scoreAndDays">
      <div class="box-item" style="margin-right: 7px">
        <div class="item-icon-container">
          <img
            class="item-icon"
            :src="require('../../../assets/imgs/my/my-score.png')"
          />
        </div>
        <div class="item-text-container">
          <div class="item-text-label">
            <span style="font-size: 16px">{{
              this.$store.getters.userInfo.rewardPoint
            }}</span
            >积分
          </div>
        </div>
      </div>
      <div
        class="box-item"
        style="margin-left: 7px"
        @click="this.action_collect"
      >
        <div class="item-icon-container">
          <img
            class="item-icon"
            :src="require('../../../assets/imgs/my/my-favorite.png')"
          />
        </div>
        <div class="item-text-container">
          <div class="item-text-label">
            收藏 <span style="font-size: 16px">{{ this.favoriteCount }}</span
            >篇文章
          </div>
        </div>
      </div>
    </div>
    <!-- 亲情账号 -->
    <div class="relation-ship-container" @click="this.action_relationShip">
      <div class="item-icon-container">
        <img
          class="item-icon"
          :src="require('../../../assets/imgs/family/my-relationship-icon.png')"
        />
      </div>
      <div class="item-text-container">
        <div class="item-text-label">亲情账号</div>
        <div class="item-text-desc">
          我的专属码：{{ this.$store.getters.userInfo.exclusiveCode }}
        </div>
      </div>
    </div>

    <!--生词本-->
    <div class="sheng-ci-ben">
      <div class="title-wra">
        <span class="lf-title">生词本</span>
        <span class="rg-btn" @click="actionLookAll">查看全部生词</span>
      </div>
      <van-divider />
      <div v-if="list && list.length > 0" class="content">
        <ShengCi :word="list[0]" @refreshWord="request_getNewwordlist" />
      </div>
      <van-empty
        v-if="!list || list.length == 0"
        description="当前没有待学单词"
      />
    </div>

    <!--支付弹窗-->
    <!-- <van-popup v-model="showPayAlert">
      <div class="aler-wrapper">
        <CommenBuyVip @itemSeleted="showPayAlert = false"></CommenBuyVip>
      </div>
    </van-popup> -->
  </div>
</template>

<script>
import * as ActionTypes from "@/store/action-types";
import moment from "moment";
import { mapGetters, mapState } from "vuex";
import CommenBuyVip from "@/components/commonBuyVip/CommenBuyVip";
import ShengCi from "./components/ShengCi";
import { getWordListWord, postRemoveWord } from "../../../api/vocab";
import { getFavoriteCount } from "../../../api/user";
import Vue from "vue";

export default {
  name: "index",
  data() {
    return {
      showPayAlert: false,
      startId: 0, //获取生词列表初始id
      list: [], //生词列表
      favoriteCount: 0,
    };
  },

  computed: mapState({
    showDate: (state) => {
      //VIP到期时间
      return moment(state.user.userInfo.vipExpireDate).format("YYYY-MM-DD");
    },
  }),

  components: {
    CommenBuyVip,
    ShengCi,
  },

  activated() {
    console.log("accessToken=======", this.$store.getters.token);

    //刷新用户信息
    this.$store.dispatch(ActionTypes.GET_USER_INFO);
    this.requestFavoriteCount();
    //获取用户生词列表
    this.request_getNewwordlist();
  },

  methods: {
    //收藏列表
    action_collect() {
      this.$router.push({
        path: "/collect",
      });
    },

    //点击购买vip
    action_addVip() {
      this.$router.push({
        path: "/payment",
      });
      // this.showPayAlert = true;
    },

    //点击查看全部生词
    actionLookAll() {
      this.$router.push({
        path: "/newwordbook",
      });
    },
    action_relationShip() {
      this.$router.push({
        path: "/relationShip",
      });
    },
    //获取生词本
    request_getNewwordlist() {
      let params = {
        size: 1,
        startId: this.startId,
      };
      // this.loading = true;
      getWordListWord(params)
        .then((res) => {
          // this.loading = false;
          if (res.code === 0) {
            let tempArr = res.data;
            this.list = tempArr;
          }
        })
        .catch((err) => {
          this.$toast(JSON.stringify(err));
        });
    },
    requestFavoriteCount() {
      getFavoriteCount().then((result) => {
        this.favoriteCount = result.data;
      });
    },
  },
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.my-wrapper {
  min-height: 100vh;
  box-sizing: border-box;
  background-color: #F7F8FB;
  padding-bottom: 60px;
}

.user-info {
  width: 100%;
  height: 200px;
  background: url('../../../assets/imgs/my/my_mybg.png') no-repeat;
  background-size: cover;
  text-align: center;

  .user-icon {
    margin: 25px 0 6px;
    width: 64px;
    height: 64px;
    border-radius: 50px;
  }

  .name-info {
    display: flex;
    justify-content: center;
    align-items: center;

    span {
      font-weight: bold;
      font-size: 14px;
      color: #333333;
      margin-right: 6px;
      padding-top: 3px;
    }

    img {
      width: 16.5px;
    }
  }
  .read-days{
    font-size: 11px;
    color: #999999
    line-height :24px;
  }
}

.vip-wrapper {
  margin: -50px 18px 0;
  height: 28vw;
  border-radius: 8px;
  overflow: hidden;

  .vip-date {
    color: #DED0B4;
    margin: 64px 12% 0;
    font-size: 12px;
  }

  .vip-btn {
    height: 26px;
    color: #CDAA79;
    margin: 64px 7% 0;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid #CDAA78;
    background-color: rgba(0, 0, 0, 0);
  }
}

.vip {
  background: url('../../../assets/imgs/my/my_vip_bg.png') no-repeat;
  background-size: cover;
}

.vip-un {
  background: url('../../../assets/imgs/my/my_unvip_bg.png') no-repeat;
  background-size: cover;
}

.scoreAndDays {
  margin: 18px 18px 0 18px;
  display: flex;
  justify-content: space-between;

  .box-item {
    display: flex;
    flex: 1;
    background-color: #fff;
    align-items: center;
    border-radius: 13px;

    .item-icon-container {
      margin: 12px 10px;
    }

    .item-icon {
      height: 42px;
      width: 42px;
    }

    .item-text-label {
      font-size: 12px;
      font-weight: bold;
      color: #333333;
      // font-family: serif;
    }

    p {
      font-weight: 14px;
      font-weight: bold;

      span {
        font-size: 22px;
      }
    }
  }
}

.sheng-ci-ben {
  background-color: #fff;
  margin: 0 18px;
  padding: 18px;
  box-shadow: 0px 8px 40px 0px rgba(194, 194, 194, 0.5);
  border-radius: 25px;

  .title-wra {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .lf-title {
      font-size: 18px;
      font-weight: bold;
      color: #333;
      font-family: serif, SimSun, STSong;
    }

    .rg-btn {
      font-size: 14px;
      color: #666;
      font-family: serif, SimSun, STSong;
    }
  }

  .action-see {
    margin-top: 20px;
    background-image: linear-gradient(to right, #3994E7, #98CEFF);
    color: #fff;
    width: 100%;
    border-radius: 50px;
  }
}

.aler-wrapper {
  background-color: #fff;
  width: calc(100vw - 20px);
  box-sizing: border-box;
  padding: 10px 20px 20px;
  border-radius: 10px;
}

.relation-ship-container {
  margin: 18px;
  display: flex;
  background: url('../../../assets/imgs/family/my-relationship-bg.png') no-repeat;
  background-size: 100% 100%;
  background-color: #0000;
  align-items: center;

  .item-icon-container {
    margin: 12px 10px;
  }

  .item-icon {
    height: 42px;
    width: 42px;
  }

  .item-text-label {
    font-size: 14px;
    font-weight: bold;
    color: #333333;
    // font-family: serif;
  }

  .item-text-desc {
    font-size: 9px;
    color: #999999;
    font-family: serif;
  }

  .my_collect {
    margin: 50px 18px 0;
    height: 28vw;
    border-radius: 8px;
    overflow: hidden;
    /* background: #3994E7 */
  }
}
</style>



// WEBPACK FOOTER //
// app/pages/tabs/Mine/index.vue